// src/screens/Admin/FeedConfigManager.js
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../../api';
import './FeedConfigManager.css';
import backIcon from '../../assets/backspace-icon.png';

function FeedConfigManager() {
  const [config, setConfig] = useState(null);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    api.get('/feed-config/config')
      .then(res => {
        console.log('✅ Loaded config:', res.data);
        setConfig(res.data.values);
      })
      .catch(err => {
        console.error('❌ Failed to load config:', err);
      })
      .finally(() => setLoading(false));
  }, []);

  const handleChange = (key, value) => {
    setConfig(prev => ({ ...prev, [key]: parseFloat(value) }));
  };

  const saveConfig = () => {
    setSaving(true);
    api.patch('/feed-config/config', config)
      .then(() => alert('✅ Feed config updated'))
      .catch(err => alert('❌ Failed to save config'))
      .finally(() => setSaving(false));
  };

  if (loading) return <div className="config-loading">Loading config...</div>;
  if (!config) return <div className="config-loading">Failed to load config.</div>;

  const keys = Object.keys(config);

  return (
    <div className="feed-config-wrapper">
      <div className="feed-config-topbar">
        <img
          src={backIcon}
          alt="Back"
          onClick={() => navigate(-1)}
        />
        <h2>Feed Scoring Config</h2>
      </div>

      <div className="feed-config-scroll">
        {keys.map((key, i) => (
          <div key={i} className="feed-config-field">
            <label>{key}</label>
            <input
              type="number"
              step="0.1"
              value={config[key]}
              onChange={e => handleChange(key, e.target.value)}
            />
          </div>
        ))}

        <div className="save-button-wrapper">
          <button onClick={saveConfig} disabled={saving}>
            {saving ? 'Saving...' : '💾 Save Changes'}
          </button>
        </div>
      </div>
    </div>
  );
}

export default FeedConfigManager;
